/* eslint-disable @typescript-eslint/no-var-requires */
import {ConfigurationApplication} from '@application/Config';
import {getAuth} from '@infra/api/authManager/authManager';
import {proxy} from '@infra/api/fetch/proxy';
import {version} from '@lookiero/look-in/package.json';
import {bootstrap, SentryEnvironment} from '@lookiero/look-in';
import {Environment} from '@domain/model/Config/Configuration';
import {PROJECT_ID} from './sentryConfig';

const configuration = ConfigurationApplication.retrieve();

const sentryConfig = (): SentryEnvironment => ({
  publicKey: '493de0c99054c688c660fc2af620954a',
  release: `look-in@${version}`,
  project: PROJECT_ID,
  environment: configuration.environment === Environment.DEVELOPMENT ? 'development' : 'production',
});

const {root, isLookInEnabled} = bootstrap({
  apiUrl: () => proxy('/look-in/api'),
  getAuthToken: getAuth as unknown as () => Promise<string>,
  sentry: sentryConfig,
});

export {root, isLookInEnabled};
